/* Decorama naambord-ontwerper – gedeelde code voor productpagina en productiebestand-pagina.
   Gebruikt GlasOntwerper (lettertypes, encode/decode) uit glas-ontwerper.js. */
(function () {
  if (window.NaambordOntwerper) return;
  var NS = 'http://www.w3.org/2000/svg';
  var COLORS = { 'Zwart': '#111111', 'Wit': '#ffffff', 'Blauw': '#1f4e9c', 'Groen': '#2e7d32', 'Rood': '#c62828', 'Geel': '#f2c200', 'Antraciet': '#383e42' };
  // grootte: lettergrootte in mm per onderdeel (Klein, Normaal, Groot, Extra groot)
  var SIZE_MM = { nr: [35, 55, 80, 0], nm: [8, 12, 16, 0] };
  var SIZE_NAMES = ['Klein', 'Normaal', 'Groot', 'Extra groot'];
  var LINE = 1.2;

  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function GO() { return window.GlasOntwerper; }

  function inPoly(poly, x, y) {
    var c = false;
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) c = !c;
    }
    return c;
  }
  function boxIn(poly, b, dx, dy) {
    dx = dx || 0; dy = dy || 0;
    var x0 = b.x + dx, y0 = b.y + dy, x1 = x0 + b.width, y1 = y0 + b.height;
    return inPoly(poly, x0, y0) && inPoly(poly, x1, y0) && inPoly(poly, x0, y1) && inPoly(poly, x1, y1) &&
      inPoly(poly, (x0 + x1) / 2, y0) && inPoly(poly, (x0 + x1) / 2, y1) && inPoly(poly, x0, (y0 + y1) / 2) && inPoly(poly, x1, (y0 + y1) / 2);
  }
  function lines(t, k) { var a = String(t || '').split('\n').map(function (s) { return s.trim(); }).filter(function (s) { return s; }); return k === 'nm' ? a.slice(0, 4) : a.slice(0, 1); }

  // strakke omtrek van de letters zelf (zonder lege ruimte boven/onder het lettertype)
  var _cv;
  function tightBox(lay, f) {
    try {
      _cv = _cv || document.createElement('canvas');
      var c = _cv.getContext('2d');
      c.font = f.style + ' ' + f.weight + ' ' + lay.fs + 'px ' + f.css;
      c.textAlign = lay.a === 'middle' ? 'center' : (lay.a === 'end' ? 'right' : 'left');
      var x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
      lay.lines.forEach(function (s, i) {
        var m = c.measureText(s), b = lay.base + i * lay.fs * LINE;
        if (m.actualBoundingBoxAscent == null) throw 0;
        x0 = Math.min(x0, lay.x - m.actualBoundingBoxLeft); x1 = Math.max(x1, lay.x + m.actualBoundingBoxRight);
        y0 = Math.min(y0, b - m.actualBoundingBoxAscent); y1 = Math.max(y1, b + m.actualBoundingBoxDescent);
      });
      if (!(x1 > x0) || !(y1 > y0)) return null;
      var p = lay.fs * 0.04;
      return { x: x0 - p, y: y0 - p, width: x1 - x0 + 2 * p, height: y1 - y0 + 2 * p };
    } catch (e) { return null; }
  }

  // een tekstblok tekenen; geeft {g, lay} terug (lay = lay-out in fotopixels)
  function drawText(parent, k, item, place, board, fill) {
    var f = GO().fontInfo(item.f);
    var ls = lines(item.t, k);
    var g = el('g', { 'data-el': k }); parent.appendChild(g);
    if (!ls.length) return { g: g, lay: null };
    var si = item.s == null ? 1 : item.s;
    // Extra groot = zo groot als het vlak toelaat
    // item.g = 2: nieuwe verdeling (Normaal/Groot gelijkmatig tussen Klein en Extra groot); oudere bestellingen zonder g houden de vaste mm-maten
    var nieuw = item.g === 2;
    var fs = (nieuw || si === 3 ? 400 : (SIZE_MM[k][si] || SIZE_MM[k][1])) * board.pxmm;
    var anchor = place.a || 'middle';
    var t = el('text', { 'text-anchor': anchor, 'font-family': f.css, 'font-style': f.style, 'font-weight': f.weight, 'data-font': f.name, fill: fill });
    g.appendChild(t);
    var lay = { x: place.x, y: place.y, fs: fs, a: anchor, n: ls.length, lines: ls, font: f.name, color: item.c };
    function apply() {
      t.setAttribute('font-size', lay.fs.toFixed(2));
      var total = (lay.n - 1) * lay.fs * LINE;
      var firstBase = place.v === 'bottom' ? lay.y - total - lay.fs * 0.28 : lay.y - total / 2 + lay.fs * 0.35;
      while (t.firstChild) t.removeChild(t.firstChild);
      ls.forEach(function (s, i) {
        var sp = el('tspan', { x: lay.x.toFixed(2), y: (firstBase + i * lay.fs * LINE).toFixed(2) });
        sp.textContent = s; t.appendChild(sp);
      });
      lay.base = firstBase;
    }
    apply();
    // passend maken in het vlak: verkleinen tot het blok erin past
    // grootte bepalen binnen het startvak (fit) van dit onderdeel; verslepen mag daarna overal in het vlak
    var poly = place.fit || board.zones[place.z].poly;
    function fit() {
      for (var i = 0; i < (nieuw ? 120 : 80); i++) {
        var b = tightBox(lay, f); if (!b) { try { b = t.getBBox(); } catch (e) { break; } }
        if (!b.width || boxIn(poly, b)) break;
        lay.fs *= nieuw ? 0.97 : 0.96; apply();
      }
    }
    fit();
    // Klein = vaste maat, Extra groot = zo groot als past; Normaal en Groot gelijkmatig daartussen
    if (nieuw && si < 3) {
      var max = lay.fs, min = Math.min(SIZE_MM[k][0] * board.pxmm, max);
      lay.fs = min + (max - min) * [0, 1 / 3, 2 / 3][si];
      apply(); fit();
    }
    g._tb = tightBox(lay, f);
    return { g: g, t: t, lay: lay };
  }

  // verschuiving (mm) beperken tot het vlak: zo ver mogelijk richting de gewenste plek
  function clampMove(g, poly, dx, dy) {
    var b = g._tb; if (!b) { try { b = g.getBBox(); } catch (e) { return [0, 0]; } }
    if (boxIn(poly, b, dx, dy)) return [dx, dy];
    var lo = 0, hi = 1;
    for (var i = 0; i < 12; i++) { var m = (lo + hi) / 2; if (boxIn(poly, b, dx * m, dy * m)) lo = m; else hi = m; }
    return [dx * lo, dy * lo];
  }

  /*
    d = { b: bord-id, nr: {t,f,c,s,z,o:[dx,dy] in mm}, nm: {...} }
    board = { pw, ph, pxmm, zones: { glas: {label, poly, origin:[x,y], size:[w,h], outline:[[x,y],...]} }, place: { 'nr@glas': {x,y,a,v} } }
  */
  async function render(svg, d, board, mode) {
    var tok = {}; svg._nbTok = tok;
    var fams = [];
    ['nr', 'nm'].forEach(function (k) { if (d[k]) fams.push(GO().fontInfo(d[k].f)); });
    if (document.fonts && document.fonts.load) {
      for (var i = 0; i < fams.length; i++) { try { await document.fonts.load(fams[i].style + ' ' + fams[i].weight + ' 20px ' + fams[i].css, '0123456789Ab'); } catch (e) {} }
    }
    if (svg._nbTok !== tok) return {};
    var layer = svg.querySelector('[data-nb-layer]');
    while (layer.firstChild) layer.removeChild(layer.firstChild);
    var out = {};
    ['nm', 'nr'].forEach(function (k) {
      var item = d[k]; if (!item) return;
      var z = board.zones[item.z] ? item.z : Object.keys(board.zones)[0];
      var place = board.place[k + '@' + z] || board.place[k] || { x: board.zones[z].center[0], y: board.zones[z].center[1], a: 'middle' };
      place = { x: place.x, y: place.y, a: place.a, v: place.v, z: z, fit: place.fit };
      var hex = COLORS[item.c] || '#111111';
      var fill = mode === 'prod' ? '#000000' : hex;
      var r = drawText(layer, k, item, place, board, fill);
      if (!r.lay) return;
      if (mode !== 'prod' && hex.toLowerCase() === '#ffffff') r.t.setAttribute('style', 'paint-order:stroke;stroke:rgba(0,0,0,.35);stroke-width:' + (r.lay.fs * 0.03).toFixed(2));
      var o = item.o || [0, 0];
      var mv = clampMove(r.g, board.zones[z].poly, o[0] * board.pxmm, o[1] * board.pxmm);
      if (mv[0] || mv[1]) r.g.setAttribute('transform', 'translate(' + mv[0].toFixed(2) + ',' + mv[1].toFixed(2) + ')');
      r.lay.dx = mv[0]; r.lay.dy = mv[1]; r.lay.z = z;
      out[k] = r.lay;
    });
    return out;
  }

  // productiebestand per vlak (glas / RVS), in mm, met de omtrek als rode haarlijn
  function productionSVG(d, board, lays, zoneId) {
    var zone = board.zones[zoneId];
    var ox = zone.origin[0], oy = zone.origin[1];
    var W = zone.size[0], H = zone.size[1];
    // schaal per onderdeel: echte maat (mm) gedeeld door de maat op de foto (px)
    var xs = zone.outline.map(function (p) { return p[0]; }), ys = zone.outline.map(function (p) { return p[1]; });
    var sx = W / (Math.max.apply(null, xs) - Math.min.apply(null, xs)), sy = H / (Math.max.apply(null, ys) - Math.min.apply(null, ys));
    var px = 2 / (sx + sy);
    function mm(v) { return (v / px).toFixed(2); }
    function mx(v) { return (v * sx).toFixed(2); }
    function my(v) { return (v * sy).toFixed(2); }
    var parts = [];
    var outline = zone.outline.map(function (p) { return mx(p[0] - ox) + ',' + my(p[1] - oy); }).join(' ');
    parts.push('<polygon id="Omtrek" points="' + outline + '" fill="none" stroke="#ff0000" stroke-width="0.1"/>');
    var info = [];
    ['nr', 'nm'].forEach(function (k) {
      var L = lays[k]; if (!L || L.z !== zoneId) return;
      var item = d[k];
      var x = L.x + (L.dx || 0) - ox, y0 = L.base + (L.dy || 0) - oy;
      var spans = L.lines.map(function (s, i) {
        return '<tspan x="' + mx(x) + '" y="' + my(y0 + i * L.fs * LINE) + '">' + s.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</tspan>';
      }).join('');
      parts.push('<text id="' + (k === 'nr' ? 'Huisnummer' : 'Naam') + '" font-family="' + L.font + '" font-size="' + mm(L.fs) + '" text-anchor="' + L.a + '" fill="' + (COLORS[item.c] || '#000000') + '">' + spans + '</text>');
      info.push((k === 'nr' ? 'huisnummer' : 'naam') + ': ' + L.lines.join(' / ') + ' (' + L.font + ', ' + (item.c || 'Zwart') + ')');
    });
    return '<?xml version="1.0" encoding="UTF-8"?>\n<!-- Decorama naambord ' + (d.b || '').toUpperCase() + ' | ' + zone.label + ' | ' + info.join(' | ') + ' | maat ' + W + ' x ' + H + ' mm -->\n' +
      '<svg xmlns="' + NS + '" width="' + W + 'mm" height="' + H + 'mm" viewBox="0 0 ' + W + ' ' + H + '">' + parts.join('') + '</svg>';
  }

  window.NaambordOntwerper = { COLORS: COLORS, SIZE_NAMES: SIZE_NAMES, render: render, productionSVG: productionSVG, clampMove: clampMove, boxIn: boxIn, lines: lines };
})();
